module.exports = __webpack_public_path__ + "img/icon_register_user.2b74ece1.svg";